<template>
  <div class="g_bg">
    <div :class="contentsClass">
      <h1><img :src="logoSrc" alt="로고" /><br/>차량 주차 위치 검색</h1>
      <ul class="car_num">
        <li><input maxlength="1" type="number" ref="carNumber0" @focus="clear" @focusout="withoutWhitespace" v-model="carNumber[0]"></li>
        <li><input maxlength="1" type="number" ref="carNumber1" @focus="clear" @focusout="withoutWhitespace" v-model="carNumber[1]"></li>
        <li><input maxlength="1" type="number" ref="carNumber2" @focus="clear" @focusout="withoutWhitespace" v-model="carNumber[2]"></li>
        <li><input maxlength="1" type="number" ref="carNumber3" @focus="clear" @focusout="withoutWhitespace" v-model="carNumber[3]"></li>
      </ul>
      <p class="btn"><a @click="search">검색</a></p>
      <h2 v-if="className == 'DONGSAN'"><img src="logo_darae.png" alt="다래파크텍 로고" /></h2>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'search',
    data() {
      return {
        carNumber:['', '', '', ''],
        tempNumber: '',
        className: '',
        logoSrc: '',
        contentsClass: '',
      };
    },
    props: ['api', 'common'],
    created() {
      this.emptyStorage();
      let common = this.common[localStorage.getItem('siteId')];
      this.logoSrc = common.logo;
      this.className = common.className;
      this.contentsClass = common.contentsClassName;
    },
    watch: {
      carNumber(value) {
        value.some((e, i) => {
          if (String(e).length > 1 || e !== '' && !this.regex(e)) {
            value[i] = '';
            this.$refs[`carNumber${i}`].focus();
            alert('숫자 하나만 입력하세요.');
            return true;
          } else if (e === '') {
            this.$refs[`carNumber${i}`].focus();
            return true;
          } else if (String(e).length === 1 && this.regex(e)) {
            this.$refs[`carNumber${i}`].blur();
          }
        });
      },
    },
    methods: {
      regex(value) {
        const re = /^\d{1}/;
        return re.test(value);
      },
      clear(element) {
        this.tempNumber = element.target.value;
        element.target.value = '';
      },
      withoutWhitespace(element) {
        if (element.target.value === '') element.target.value = this.tempNumber;
      },
      search() {
        const carNumber = this.carNumber.join('');
        if (carNumber.length !== 4) return alert('차량번호를 확인해주세요.');

        this.$http.get(this.api.dataUrl(window.localStorage.getItem('siteId')) + carNumber)
            .then(response => {
            if (!this._.isEmpty(response.data.items)) {
            this.existItem(response.data.items, carNumber);
          } else {
            this.emptyItem(carNumber);
          }
        })
        .catch(err => {
          alert(`서버에서 오류가 발생했습니다. \n${err}`);
        });
      },
      existItem(items, carNumber) {
        let carItems = items.map(e => {
          e.imageUrl = this.api.imgUrl + e.site.siteId + '/slots/' +  e.slotImg;
          e.thumbnailMap = `noimage`;
        return e;
      });
        this.$store.commit({
          type: 'addCarItems',
          carItems: carItems
        });
        this.$store.commit({
          type: 'addCarNumber',
          carNumber: carNumber
        });
        sessionStorage.setItem('carItems', JSON.stringify(carItems));
        sessionStorage.setItem('carNumber', carNumber);
        this.$router.push('/list');
      },
      emptyStorage() {
        Object.keys(sessionStorage).forEach(e => sessionStorage.removeItem(e));
      },
      emptyItem(carNumber) {
        this.$store.commit({
          type: 'addCarNumber',
          carNumber: carNumber
        });
        this.$router.push('/empty');
      }
    }
  };
</script>

<style scoped>

</style>
